var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import EncryptUtils from '@popup/steem/utils/encrypt.utils';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import LocalStorageUtils from 'src/utils/localStorage.utils';
const getAccountsFromFileData = (fileContent, mk) => {
    try {
        const accounts = EncryptUtils.decryptToJsonWithoutMD5Check(fileContent, mk);
        if (accounts) {
            return accounts === null || accounts === void 0 ? void 0 : accounts.list;
        }
        else {
            return [];
        }
    }
    catch (e) {
        throw new Error();
    }
};
const mergeImportedAccountsToExistingAccounts = (importedAccounts, existingAccounts) => __awaiter(void 0, void 0, void 0, function* () {
    const newAccounts = [];
    importedAccounts = importedAccounts.filter((e) => { var _a, _b; return ((_a = e.keys.active) === null || _a === void 0 ? void 0 : _a[0]) !== '#' && ((_b = e.keys.posting) === null || _b === void 0 ? void 0 : _b[0]) !== '#'; });
    for (const importedAccount of importedAccounts) {
        if (existingAccounts
            .map((existingAccount) => existingAccount.name)
            .includes(importedAccount.name)) {
            const existingAccount = existingAccounts.find((existingAccount) => existingAccount.name === importedAccount.name);
            if (!existingAccount)
                continue;
            const account = {
                name: existingAccount.name,
                keys: existingAccount.keys,
            };
            if (importedAccount.keys.active && !existingAccount.keys.active) {
                account.keys.active = importedAccount.keys.active;
                account.keys.activePubkey = importedAccount.keys.activePubkey;
            }
            if (importedAccount.keys.memo && !existingAccount.keys.memo) {
                account.keys.memo = importedAccount.keys.memo;
                account.keys.memoPubkey = importedAccount.keys.memoPubkey;
            }
            if (importedAccount.keys.posting && !existingAccount.keys.posting) {
                account.keys.posting = importedAccount.keys.posting;
                account.keys.postingPubkey = importedAccount.keys.postingPubkey;
            }
            newAccounts.push(account);
        }
        else {
            newAccounts.push(importedAccount);
        }
    }
    for (const existingAccount of existingAccounts) {
        if (!newAccounts
            .map((existingAccount) => existingAccount.name)
            .includes(existingAccount.name)) {
            newAccounts.push(existingAccount);
        }
    }
    return newAccounts;
});
const getAccountsFromLocalStorage = (mk) => __awaiter(void 0, void 0, void 0, function* () {
    const encryptedAccounts = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.ACCOUNTS);
    const accounts = EncryptUtils.decryptToJson(encryptedAccounts, mk);
    return accounts === null || accounts === void 0 ? void 0 : accounts.list;
});
const BgdAccountsUtils = {
    getAccountsFromFileData,
    mergeImportedAccountsToExistingAccounts,
    getAccountsFromLocalStorage,
};
export default BgdAccountsUtils;
